var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97168 3.5C5.50807 3.50014 5.94238 3.9478 5.94238 4.5V17.5C5.94238 18.0522 6.37766 18.4999 6.91406 18.5H19.0283C19.5648 18.5 20 18.9477 20 19.5C20 20.0523 19.5648 20.5 19.0283 20.5H6.91406C5.30465 20.4999 4 19.1568 4 17.5V4.5C4 3.94772 4.43517 3.5 4.97168 3.5ZM18.293 7.20703C18.9229 6.57721 19.9999 7.02329 20 7.91406V15.5C20 16.0523 19.5523 16.5 19 16.5H9C8.44772 16.5 8 16.0523 8 15.5V12.9141C8.00004 12.6489 8.10547 12.3945 8.29297 12.207L11.793 8.70703C12.1835 8.31661 12.8165 8.31661 13.207 8.70703L14.293 9.79297C14.6835 10.1834 15.3165 10.1834 15.707 9.79297L18.293 7.20703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco16);
export default __webpack_public_path__ + "static/media/Gnb_ico_16.0c41245d7865b8b5f1bbb4464e602ae6.svg";
export { ForwardRef as ReactComponent };